import { Project } from "../../../../js/parsegenerated";

export function getProjectIcon(project: Project) {
  return project?.get("icon") ?? "fa:file-chart-line";
}
